<template>
  <div class="container mt-5 text-center">
    <h2 class="fw-bold">관리자 대시보드</h2>
    <p class="text-muted">좌측 메뉴에서 관리 항목을 선택하세요.</p>
  </div>
</template>

<script>
export default {
  name: 'AdminDashboardView'
}
</script>
